import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { CONSTANTS_CRM, Outcome } from '@fitness-force/constants';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'outcome',
  templateUrl: './outcome.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class OutcomeComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null)
  @Input() dataProperty: string;
  constructor() { }
  ngOnInit(): void {
  }

  getOutCome(value: number, row: any): Outcome | undefined {
    if (row != null) {
      if (row.tsk_type == 1) //call
        return CONSTANTS_CRM.CALL_OUTCOME.find(element => element.value == value);
      else if (row.tsk_type == 5) //Tour
        return CONSTANTS_CRM.TOUR_OUTCOME.find(element => element.value == value);
      else
        return CONSTANTS_CRM.CALL_OUTCOME.find(element => element.value == value);
    }
    else {
      return CONSTANTS_CRM.CALL_OUTCOME.find(element => element.value == value);
    }
  }
} 
